import { EPROTECT, SessionService } from '@amwager/data-access';
import { FundingFacade, IDebitCreditCard } from '@amwager/funding/data-access';
import { LoadService, UnsubscribeObservableService } from '@amwager/util';
import { IDCCard, IEProtect, eProtectConfigure } from '@amwager/util-ts';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AlertController, IonButton } from '@ionic/angular/standalone';
import { Subscription, interval, startWith, takeUntil } from 'rxjs';

// from JS eProtect iFrame CDN
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let EprotectIframeClient: any; // class
declare let iframeIsReady: boolean | undefined; // property

// will determine if data is to submit,
// set this to null if you don't want to submit
let callbackDataResponse: IDCCard | undefined = undefined;
// let $timeout = null;
let showErrorMsg: string;



@Component({
  selector: 'feature-ion-add-account-card',
  templateUrl: './add-account-card.component.html',
  styleUrls: ['./add-account-card.component.scss'],
  imports: [
    IonButton,
    CommonModule
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddAccountCardComponent extends UnsubscribeObservableService
  implements OnInit, OnChanges, OnDestroy {

  @Input() showAddCard: boolean = false;
  @Output() showAddCardFn = new EventEmitter<boolean>();

  @ViewChild('eProtectIframeTemplate') eProtectIframeTemplate!: ElementRef;
  @ViewChild('eProtectiframe') eProtectiframe!: ElementRef;

  eProtectiframeClient: any;
  // iframeClient: any;

  $invervalIframeIsReady!: Subscription;
  $isEProtectURLLoaded!: Subscription;


  private subsAddCardResponse!: Subscription;
  isIFrameReady: boolean = false;
  // @Input() showAddCard: boolean = false;

  isEProtectURLLoaded: boolean = false;

  cardAccountValidCheckerTimeout: any;

  constructor(
    @Inject(EPROTECT) private readonly eProtect: IEProtect,
    private readonly loadService: LoadService,
    private readonly alertCtrl: AlertController,
    private readonly sessionService: SessionService,
    private readonly fundingFacade: FundingFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly elementRef: ElementRef,
  ) {
    super();

    // this.loadCDNs();
  }

  ngOnChanges(): void {
    // null;

    // this.loadCDNs();
    if (this.showAddCard) this.loadCDNs();
    else {
      this.isEProtectURLLoaded = false;
      this.isIFrameReady = false;
      this.clearStateProcess();
      this.removeCDNs();
      this.cdRef.markForCheck();
    }
    // else {
    //   this.clearStateProcess();
    //   this.removeCDNs();
    // }
  }

  ngOnInit(): void {
    null;
    // this.addBtnState(false); //set button state
  }

  // ngAfterViewInit(): void {
  //   this.addBtnState(false); //set button state
  // }

  override ngOnDestroy(): void {
    this.isEProtectURLLoaded = false;
    this.clearStateProcess();
    this.removeCDNs();
  }

  addBtnState(state: boolean = true): void {
    // show btn add or adding

    if (!this.eProtectIframeTemplate) return;

    if (state) { // show adding
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-add'].hidden = true;
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-adding'].hidden = false;
    }
    else { // show add
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-add'].hidden = false;
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-adding'].hidden = true;
    }
  }

  loadCDNs(): void {
    if (this.isEProtectURLLoaded) return;

    this.clearStateProcess();
    this.removeCDNs();

    const scriptsToAdd = [
      { id: 'JQueryCDN', url: this.eProtect.jQuery },
      { id: 'eProtectCDN', url: this.eProtect.url }
    ];

    this.loadService.addScripts(scriptsToAdd)
    .then(() => {
      console.log('EProtect scripts added successfully!');

      this.isEProtectURLLoaded = true;
      this.cdRef.markForCheck();

      this.eProtectIframeClientIsReadyChecker();
    })
    .catch(error => {
      console.log('ERROR: EProtect scripts loading failed:', error);

      this.isEProtectURLLoaded = false;
      this.cdRef.markForCheck();
    });
  }


  removeCDNs(): void {
    if (!this.isEProtectURLLoaded) return;

    const scriptsToRemove = ['JQueryCDN','eProtectCDN'];

    this.loadService.removeScripts(scriptsToRemove)
    .then(() => {
      console.log('EProtect scripts removed successfully!');

      this.isEProtectURLLoaded = false;
      this.cdRef.markForCheck();
    })
    .catch(error => {
      console.log('ERROR: EProtect scripts removal failed:', error);
    });
  }

  clearStateProcess(): void {

    if (this.$invervalIframeIsReady) this.$invervalIframeIsReady.unsubscribe();
    if (this.$isEProtectURLLoaded) this.$isEProtectURLLoaded.unsubscribe();
    if (this.cardAccountValidCheckerTimeout) clearTimeout(this.cardAccountValidCheckerTimeout);
    // this.funding$.setEProtectURLLoaded(false);

    this.eProtectiframeClient = undefined;
    // if (typeof EprotectIframeClient !== 'undefined') EprotectIframeClient = undefined;
    if (typeof iframeIsReady !== 'undefined') iframeIsReady = undefined;
    callbackDataResponse = undefined;

    this.cdRef.markForCheck();
  }

  inputsEmptyCallBack(response: any): void {
    // console.log('inputsEmptyCallBack:', response);
    null;
  }

  eProtectConfigureSettings(): void {
    if (!EprotectIframeClient) {
      this.showAddCardFn.emit(false);
      this.showAlertMessage('Error', 'EProtect failure. Kindly contact support.');
      return;
    }

    try {
      this.eProtectiframeClient = new EprotectIframeClient(
        eProtectConfigure(
          this.sessionService.getPayPageId(),
          this.eProtect.css,
          this.eProtect.reportGroup,
          this.eProtectIframeClientCallBack,
          this.inputsEmptyCallBack
        )
      );

      this.eProtectiframeClient.autoAdjustHeight();
    } catch (error) {
      console.log("ERROR:", error);
    }


    this.iFrameIsReadyChecker();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eProtectIframeClientCallBack(response: any): void {
    // const ERROR_FETCH: string = "Could not add card, please try again later or contact support.";
    // const EXPIRATION_DATE_INVALID: string = "Card can't be added. Please fill Card Expiration Date properly.";
    const EXPIRATION_DATE_EXPIRED: string = "Card can't be added. Card is already expired.";
    // const CARD_NUMBER_INVALID: string = "Please check and re-enter your card number and try again.";
    // const CARD_VALIDATION_INVALID: string = "Please check and re-enter your card validation number and try again.";
    // const CARD_TYPE_INVALID: string = "Sorry we only accept Visa, Discover and MasterCard. Please try again.";
    // const FAILED_CSS: string = "Failed to load CSS.";
    // const FAILED_IFRAME: string = "Failed to load Iframe";

    // console.log('eprotect:response:', response)

    if (response.response == 870) {
      if (String(response.type).toLowerCase() === 'vi' ||
          String(response.type).toLowerCase() === 'mc'
        ) {
        if (!response.expMonth || !response.expYear) showErrorMsg = EXPIRATION_DATE_EXPIRED;

        callbackDataResponse = {
          "OrderId": response.orderId,
          "Id": response.id,
          "PaypageRegistrationId": response.paypageRegistrationId,
          "Bin": response.bin,
          "ExpMonth": response.expMonth,
          "ExpYear": response.expYear,
          "FirstSix": response.firstSix,
          "LastFour": response.lastFour,
          "InvokeMerchantCallback": response.invokeMerchantCallback,
          "Message": response.message,
          "ReportGroup": response.reportGroup,
          "Response": response.response,
          "ResponseTime": response.responseTime,
          "TargetServer": response.targetServer,
          "Type": response.type,
          "VantivTxnId": response.vantivTxnId
        };
      }
      else {
        showErrorMsg = "Could not add card, please try again later or contact support."
      }
    }
    else {
      showErrorMsg = response.message || (response?.timeout ? 'Timeout' : 'unknown issue');
    }
  }

  eProtectIframeClientIsReadyChecker(): void {
    this.$isEProtectURLLoaded = interval(500).pipe(startWith(0)).subscribe( () => {

      if (EprotectIframeClient) { // EprotectIframeClient is loaded
        setTimeout(() => {
          this.eProtectConfigureSettings();
          this.addBtnState(false);
        }, 300);

        if (this.$isEProtectURLLoaded) this.$isEProtectURLLoaded.unsubscribe();
      }
    });
  }

  iFrameIsReadyChecker(): void {
    this.$invervalIframeIsReady = interval(500).pipe(startWith(0)).subscribe( () => {

      if (iframeIsReady) { // Iframe is loaded
        setTimeout(() => {
          this.isIFrameReady = Boolean(iframeIsReady);
        }, 300);
        if (this.$invervalIframeIsReady) this.$invervalIframeIsReady.unsubscribe();
        this.cardAccountValidChecker();

        this.cdRef.markForCheck();
      }
      else if (!this.eProtectIframeTemplate && showErrorMsg) {
        this.showAlertMessage('Error', showErrorMsg);
        showErrorMsg = '';
      }
    });
  }

  cardAccountValidChecker(): void {
    if (!this.showAddCard) {
      if (this.cardAccountValidCheckerTimeout) clearTimeout(this.cardAccountValidCheckerTimeout);
      return;
    }

    if (showErrorMsg && this.showAddCard) {
      this.showAlertMessage('Error', showErrorMsg);
      showErrorMsg = '';
    }

    // submit/send to api if callbackDataResponse has data
    if (callbackDataResponse) this.insertCard(callbackDataResponse);
    else {
      this.cardAccountValidCheckerTimeout = setTimeout(() => {
        this.cardAccountValidChecker();
      }, 500);
    }
  }

  insertCard(newCard: IDebitCreditCard): void {
    callbackDataResponse = undefined
    this.fundingFacade.addDebitCreditCard(newCard);

    this.subsAddCardResponse?.unsubscribe();
    this.subsAddCardResponse = this.fundingFacade.isAddDebitCreditCardSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe(({response, isSuccess}) => {
      this.addBtnState(false);
      this.clearStateProcess();

      if (!isSuccess && response?.error) {
        this.showAlertMessage('Error' ,response?.error?.Message || 'Error');
      }
    });
  }


  addCard(): void {
    if (!this.eProtectiframeClient) {
      console.log('ERROR: no eProtectiframeClient')
      return;
    }

    this.addBtnState(true);

    const id = this.sessionService.generateSessionId();
    const orderId = this.sessionService.generateSessionId();

    const message = {
      "id":  btoa(id).substring(0,24), //unique, max 25
      "orderId": btoa(orderId).substring(0, 24), //unique, max 256
    };

    this.eProtectiframeClient.getPaypageRegistrationId(message);
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    this.addBtnState(false);

    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

}
